// 统一前端站点配置：优先读取运行时文件 frontend/public/runtime-config.js
// 其次读取编译期变量 REACT_APP_*，最后回落到默认值

const runtime = (typeof window !== 'undefined' && window.RUNTIME_CONFIG) ? window.RUNTIME_CONFIG : {};

// 计算安全默认地址（不硬编码远端域名）
function getDefaultOrigin() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return 'http://localhost:3000';
}

/**
 * 本地 CRA 开发服占用同源 /ws 做 HMR，不能再给业务 WebSocket 用。
 * 开发时默认直连后端 5000；生产/网关同源则走当前域名 /ws。
 */
function isPrivateLanHost(hostname) {
  if (!hostname) return false;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return true;
  // 常见内网段：指挥端用 http://192.168.x.x:3000 打开 CRA 时，/ws 会被 HMR 占住
  if (/^10\.\d+\.\d+\.\d+$/.test(hostname)) return true;
  if (/^192\.168\.\d+\.\d+$/.test(hostname)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d+\.\d+$/.test(hostname)) return true;
  return false;
}

function getDefaultWsUrl() {
  if (typeof window !== 'undefined' && window.location) {
    const { hostname, protocol, port } = window.location;
    const isCraDevPort = !port || port === '3000' || port === '3001' || port === '5001';
    // 本机 / 局域网 CRA：业务 WS 必须直连后端 5000，不能用同源 /ws（CRA HMR）
    if (isPrivateLanHost(hostname) && isCraDevPort) {
      const wsProto = protocol === 'https:' ? 'wss' : 'ws';
      return `${wsProto}://${hostname}:5000/ws`;
    }
    const wsProto = protocol === 'https:' ? 'wss' : 'ws';
    return `${wsProto}://${window.location.host}/ws`;
  }
  return 'ws://localhost:5000/ws';
}

function pick(value, fallback) {
  return value !== undefined && value !== null && value !== '' ? value : fallback;
}

const config = {
  // 运行时与编译期变量合并后的API/WS配置
  api: {
    baseUrl: pick(
      runtime.API_BASE_URL,
      process.env.REACT_APP_API_BASE_URL || `${getDefaultOrigin()}/api`
    ),
    wsUrl: pick(
      runtime.WS_URL,
      process.env.REACT_APP_WS_URL || getDefaultWsUrl()
    ),
    streamingUrl: pick(
      runtime.STREAMING_URL,
      process.env.REACT_APP_STREAMING_URL || `${getDefaultOrigin()}/api/streaming`
    ),
  },

  domain: {
    full: pick(
      runtime.DOMAIN,
      process.env.REACT_APP_DOMAIN || getDefaultOrigin()
    ),
  },

  getApiUrl() {
    return this.api.baseUrl;
  },

  getWsUrl() {
    return this.api.wsUrl;
  },

  getStreamingUrl() {
    return this.api.streamingUrl;
  },

  getDomain() {
    return this.domain.full;
  }
};

export default config;

if (typeof window !== 'undefined') {
  window.SITE_CONFIG = config;
}
